import { openDB } from 'idb';
const DB_NAME = `prep-chef`;
const DB_VERSION = 1;


const dflt = {
    "pc_stores" : [
        {
            "uid": "cf81",
            "logoId": "cf81",
            "name": "Albertsons"
        },
        {
            "uid": "4e3a",
            "logoId": "4e3a",
            "name": "Amazon Fresh"
        },
        {
            "uid": "014b",
            "logoId": "014b",
            "name": "Costco"
        },
        {
            "uid": "5952",
            "logoId": "5952",
            "name": "Fresh Market"
        },
        {
            "uid": "989c",
            "logoId": "989c",
            "name": "Kroger"
        },
        {
            "uid": "e8c8",
            "logoId": "e8c8",
            "name": "Publix"
        },
        {
            "uid": "c74c",
            "logoId": "c74c",
            "name": "Safeway"
        },
        {
            "uid": "4f7f",
            "logoId": "4f7f",
            "name": "ShopRite"
        },
        {
            "uid": "c2ea",
            "logoId": "c2ea",
            "name": "Target"
        },
        {
            "uid": "20ef",
            "logoId": "20ef",
            "name": "Trader Joe's"
        },
        {
            "uid": "f72a",
            "logoId": "f72a",
            "name": "Walmart"
        },
        {
            "uid": "188d",
            "logoId": "188d",
            "name": "Wegmans"
        },
        {
            "uid": "ac40",
            "logoId": "ac40",
            "name": "Whole Foods"
        },
        {
            "uid": "de55",
            "logoId": "de55",
            "name": "Other store"
        }
    ],
    "pc_products" : [
        // ##### DAIRY #####
        {
            "uid": "d780505c3d15",
            "name": "Milk",
            "category": "dairy"
        },
        {
            "uid": "9a62ab69caf5",
            "name": "Buttermilk",
            "category": "dairy"
        },
        {
            "uid": "840c86328740",
            "name": "Half & Half",
            "category": "dairy"
        },
        {
            "uid": "b8df2b2053be",
            "name": "Whipping Cream",
            "category": "dairy"
        },
        {
            "uid": "00d520de3517",
            "name": "Whipped Cream",
            "category": "dairy"
        },
        {
            "uid": "ce353db350f2",
            "name": "Soy Milk",
            "category": "dairy"
        },
        {
            "uid": "1bcd70e34d6c",
            "name": "Almond Milk",
            "category": "dairy"
        },
        {
            "uid": "aad2e1e35054",
            "name": "Oat Milk",
            "category": "dairy"
        },
        {
            "uid": "b84884e57179",
            "name": "Rice Milk",
            "category": "dairy"
        },
        {
            "uid": "f785b2b1667f",
            "name": "Cashew Milk",
            "category": "dairy"
        },
        {
            "uid": "287c9be18bd7",
            "name": "Coconut Milk",
            "category": "dairy"
        },
        {
            "uid": "d21f3002d986",
            "name": "Creamer",
            "category": "dairy"
        },
        {
            "uid": "c1e69de53cb5",
            "name": "Creme Fraiche",
            "category": "dairy"
        },
        {
            "uid": "a4f51a02736b",
            "name": "Sour Cream",
            "category": "dairy"
        },
        {
            "uid": "77b6f7f890e2",
            "name": "Clotted Cream",
            "category": "dairy"
        },
        {
            "uid": "304626205954",
            "name": "Evaporated Milk",
            "category": "dairy"
        },
        {
            "uid": "6a9c2fd2b583",
            "name": "Goat Milk",
            "category": "dairy"
        },
        {
            "uid": "1b95af2ba8f0",
            "name": "Chocolate Milk",
            "category": "dairy"
        },
        {
            "uid": "1b8a39d3e8a2",
            "name": "Condensed Coconut Milk",
            "category": "dairy"
        },
        {
            "uid": "470dcf99e234",
            "name": "Condensed Milk",
            "category": "dairy"
        },
        // ##### BUTTER #####
        {
            "uid": "048920e16b95",
            "name": "Ghee",
            "category": "dairy"
        },
        {
            "uid": "e2b721013138",
            "name": "Salted Butter",
            "category": "dairy"
        },
        {
            "uid": "73b02a549c14",
            "name": "Unsalted Butter",
            "category": "dairy"
        },
        {
            "uid": "eb2d6f105862",
            "name": "European Style Salted Butter",
            "category": "dairy"
        },
        {
            "uid": "07418cf0428f",
            "name": "European Style Unsalted Butter",
            "category": "dairy"
        },
        {
            "uid": "0ad171ca0387",
            "name": "Goat Butter",
            "category": "dairy"
        },
        {
            "uid": "29951a1f4989",
            "name": "Avocado Oil Butter",
            "category": "dairy"
        },
        {
            "uid": "73a7d3d3e99c",
            "name": "Soy Free Buttery Spread",
            "category": "dairy"
        },
        {
            "uid": "d715c1c456e4",
            "name": "Margarine",
            "category": "dairy"
        },
        // ##### FRUITS #####
        
        {
            "uid": "a6ba547d18ab",
            "name": "Apricot",
            "category": "fruits"
        },
        {
            "uid": "d62cb573ffb2",
            "name": "Aprium",
            "category": "fruits"
        },
        {
            "uid": "081fa364177c",
            "name": "Asian Pear",
            "category": "fruits"
        },
        {
            "uid": "6c37f781dea6",
            "name": "Açai Berry",
            "category": "fruits"
        },
        {
            "uid": "b58bc56688e3",
            "name": "Black Cherry",
            "category": "fruits"
        },
        {
            "uid": "1ea6b44db2a8",
            "name": "Carambola",
            "category": "fruits"
        },
        {
            "uid": "e7ac1e584c3f",
            "name": "Cherimoya",
            "category": "fruits"
        },
        {
            "uid": "516cb8b8a657",
            "name": "Cranberry",
            "category": "fruits"
        },
        {
            "uid": "2b436c286e62",
            "name": "Durian",
            "category": "fruits"
        },
        {
            "uid": "1a8db2b01ffe",
            "name": "Fig",
            "category": "fruits"
        },
        {
            "uid": "68e0d7b9dd78",
            "name": "Goji Berry",
            "category": "fruits"
        },
        {
            "uid": "d69c71cb5e82",
            "name": "Golden Apple",
            "category": "fruits"
        },
        {
            "uid": "a9df697f4d33",
            "name": "Gooseberry",
            "category": "fruits"
        },
        
        {
            "uid": "c279ce294668",
            "name": "Apple - Green",
            "category": "fruits"
        },
        {
            "uid": "979e5cdcac4d",
            "name": "Guava",
            "category": "fruits"
        },
        {
            "uid": "5982066705a1",
            "name": "Huckleberry",
            "category": "fruits"
        },
        {
            "uid": "795af838bf7c",
            "name": "Jackfruit",
            "category": "fruits"
        },
        {
            "uid": "d1d836d2139b",
            "name": "Kumquat",
            "category": "fruits"
        },
        {
            "uid": "4a7847d40132",
            "name": "Longan",
            "category": "fruits"
        },
        {
            "uid": "e32bd7ee3d3a",
            "name": "Lychee",
            "category": "fruits"
        },
        {
            "uid": "3d31e56e5001",
            "name": "Passion fruit",
            "category": "fruits"
        },
        {
            "uid": "20d383f89bc9",
            "name": "Persimmon",
            "category": "fruits"
        },
        {
            "uid": "cdb796ce3af3",
            "name": "Pineapple",
            "category": "fruits"
        },
        {
            "uid": "e0265994a955",
            "name": "Pluot",
            "category": "fruits"
        },
        {
            "uid": "a7e382663caa",
            "name": "Pomelo",
            "category": "fruits"
        },
        {
            "uid": "66d81bb6b031",
            "name": "Quince",
            "category": "fruits"
        },
        {
            "uid": "9f33e6db271e",
            "name": "Rhubarb",
            "category": "fruits"
        },
        {
            "uid": "ebee00dc029c",
            "name": "Sapodilla",
            "category": "fruits"
        },
        {
            "uid": "97da8b6b80d0",
            "name": "Sugarcane",
            "category": "fruits"
        },
        {
            "uid": "7a85a3e5dd94",
            "name": "star fruit",
            "category": "fruits"
        },
        {
            "uid": "f563c6c0653b",
            "name": "Apple",
            "category": "fruits"
        },
        {
            "uid": "0e23506f0855",
            "name": "Avocado",
            "category": "fruits"
        },
        {
            "uid": "55baba3433c4",
            "name": "Baby Banana",
            "category": "fruits"
        },
        {
            "uid": "f56d11e5d6b7",
            "name": "Pear - Anjou",
            "category": "fruits"
        },
        {
            "uid": "390055eb7890",
            "name": "Juicing Orange",
            "category": "fruits"
        },
        {
            "uid": "c03ef317b831",
            "name": "Lime",
            "category": "fruits"
        },
        {
            "uid": "3656943240c6",
            "name": "Lemon",
            "category": "fruits"
        },
        {
            "uid": "270e23c59eae",
            "name": "Lemon - Meyer",
            "category": "fruits"
        },
        {
            "uid": "4636b75b4169",
            "name": "Banana",
            "category": "fruits"
        },
        {
            "uid": "6c99811b8552",
            "name": "Pear - Bartlett",
            "category": "fruits"
        },
        {
            "uid": "9e0e8a4e2fa7",
            "name": "Plum - Black",
            "category": "fruits"
        },
        {
            "uid": "c96d58c7f1cb",
            "name": "Grape - Black",
            "category": "fruits"
        },
        {
            "uid": "d0e35421f384",
            "name": "Blackberry",
            "category": "fruits"
        },
        {
            "uid": "1f08ed7efe25",
            "name": "Blood Orange",
            "category": "fruits"
        },
        {
            "uid": "696171dd012e",
            "name": "Blueberry",
            "category": "fruits"
        },
        {
            "uid": "3c23ef8f7234",
            "name": "Cherry - Rainier",
            "category": "fruits"
        },
        {
            "uid": "9790e6250be6",
            "name": "Melon",
            "category": "fruits"
        },
        {
            "uid": "62808ce6ebbe",
            "name": "Cantaloupe",
            "category": "fruits"
        },
        {
            "uid": "ce5006d23d17",
            "name": "Cherry",
            "category": "fruits"
        },
        {
            "uid": "256d86fe1eec",
            "name": "Coconut",
            "category": "fruits"
        },
        {
            "uid": "73e9137de2de",
            "name": "Apple - Cripps Pink",
            "category": "fruits"
        },
        {
            "uid": "5538110228e7",
            "name": "Watermelon",
            "category": "fruits"
        },
        {
            "uid": "6886b696244a",
            "name": "Pear",
            "category": "fruits"
        },
        {
            "uid": "e7eb4a94825f",
            "name": "Dragon Fruit",
            "category": "fruits"
        },
        {
            "uid": "81cb3de1e700",
            "name": "Fruit Salad",
            "category": "fruits"
        },
        {
            "uid": "9767a1535f29",
            "name": "Apple - Fuji",
            "category": "fruits"
        },
        {
            "uid": "baa9387094aa",
            "name": "Apple - Gala",
            "category": "fruits"
        },
        {
            "uid": "179f83a4c051",
            "name": "Mandarin",
            "category": "fruits"
        },
        {
            "uid": "b7ee1b5a935c",
            "name": "Apple - Granny Smith",
            "category": "fruits"
        },
        {
            "uid": "cac8b8b0471d",
            "name": "Tomato - Grape",
            "category": "fruits"
        },
        {
            "uid": "3ce5da58c23f",
            "name": "Grape - Green",
            "category": "fruits"
        },
        {
            "uid": "58eaf78cec0c",
            "name": "Grape",
            "category": "fruits"
        },
        {
            "uid": "12ab32cc581c",
            "name": "Apple - Honeycrisp",
            "category": "fruits"
        },
        {
            "uid": "e34d71eb78f8",
            "name": "Honeydew",
            "category": "fruits"
        },
        {
            "uid": "93fab40bbcfa",
            "name": "Tomatillo",
            "category": "fruits"
        },
        {
            "uid": "f7179f0fbde9",
            "name": "Key Lime",
            "category": "fruits"
        },
        {
            "uid": "b8bd0e1cd5de",
            "name": "Strawberry",
            "category": "fruits"
        },
        {
            "uid": "7d7137b6823a",
            "name": "Plantain",
            "category": "fruits"
        },
        {
            "uid": "278e4f1b765d",
            "name": "Mango",
            "category": "fruits"
        },
        {
            "uid": "9b8c2e8f53ea",
            "name": "Date",
            "category": "fruits"
        },
        {
            "uid": "18be4b4d0007",
            "name": "Papaya",
            "category": "fruits"
        },
        {
            "uid": "40c29d7fd65c",
            "name": "Mini Watermelon",
            "category": "fruits"
        },
        {
            "uid": "f8e9c998699d",
            "name": "Mixed Berries",
            "category": "fruits"
        },
        {
            "uid": "971ecc20bb4d",
            "name": "Mixed Melons",
            "category": "fruits"
        },
        {
            "uid": "2d137a3ad209",
            "name": "Orange - Navel",
            "category": "fruits"
        },
        {
            "uid": "6611651b6e1d",
            "name": "Nectarine",
            "category": "fruits"
        },
        {
            "uid": "3754175d1413",
            "name": "Peach",
            "category": "fruits"
        },
    
        {
            "uid": "ffb216c43d68",
            "name": "Pomegranate",
            "category": "fruits"
        },
        {
            "uid": "7abe9c3163dc",
            "name": "Raspberry",
            "category": "fruits"
        },
        {
            "uid": "689f6788c799",
            "name": "Cherry - Red",
            "category": "fruits"
        },
        {
            "uid": "8f292d6327e9",
            "name": "Grapefruit - Red",
            "category": "fruits"
        },
        {
            "uid": "bc4275ebb258",
            "name": "Grapefruit",
            "category": "fruits"
        },
        {
            "uid": "f3245d857e88",
            "name": "Mango - Red",
            "category": "fruits"
        },
        {
            "uid": "daeefcdadbed",
            "name": "Plum - Red",
            "category": "fruits"
        },
        {
            "uid": "87dee02e8405",
            "name": "Grape - Red",
            "category": "fruits"
        },
        {
            "uid": "ff46d70e6eae",
            "name": "Kiwi",
            "category": "fruits"
        },
        {
            "uid": "7718c5a89a18",
            "name": "Orange",
            "category": "fruits"
        },
        {
            "uid": "552adf926741",
            "name": "Tangerine",
            "category": "fruits"
        },
        {
            "uid": "89b2c80bd3b9",
            "name": "Tropical Fruit Mix",
            "category": "fruits"
        },
        {
            "uid": "59d461e2db83",
            "name": "Nectarine - White",
            "category": "fruits"
        },
        {
            "uid": "42008f6dd8a1",
            "name": "Peach - White",
            "category": "fruits"
        },
        {
            "uid": "ae1727403310",
            "name": "Peach - Yellow",
            "category": "fruits"
        },
        {
            "uid": "11da1cdcea94",
            "name": "Young Coconut",
            "category": "fruits"
        },
        {
            "uid": "",
            "name": "Plum",
            "category": "fruits"
        },
        // ##### SEAFOOD #####
        {
            "uid": "6b0d8875a746",
            "name": "Albacore Tuna",
            "category": "seafood"
        },
        {
            "uid": "478d2a6ce2dc",
            "name": "Atlantic Cod",
            "category": "seafood"
        },
        {
            "uid": "3bd0a458ff45",
            "name": "Atlantic Salmon",
            "category": "seafood"
        },
        {
            "uid": "6ad6237465ab",
            "name": "Beer Battered Cod Fillets",
            "category": "seafood"
        },
        {
            "uid": "63fda3875c4d",
            "name": "Salmon Burgers",
            "category": "seafood"
        },
        {
            "uid": "378095ef7da4",
            "name": "Alaska Pink Salmon",
            "category": "seafood"
        },
        {
            "uid": "bc20f142bc37",
            "name": "Fish sticks",
            "category": "seafood"
        },
        {
            "uid": "1fd18f4dae9f",
            "name": "Sardines",
            "category": "seafood"
        },
        {
            "uid": "9ec24e7ccd8b",
            "name": "Chilean Sea Bass",
            "category": "seafood"
        },
        {
            "uid": "d4535835b197",
            "name": "Cold Smoked Salmon",
            "category": "seafood"
        },
        {
            "uid": "baa94d7a528b",
            "name": "Sockeye Salmon",
            "category": "seafood"
        },
        {
            "uid": "9877491e0baf",
            "name": "Halibut",
            "category": "seafood"
        },
        {
            "uid": "c049dbf7a356",
            "name": "King Salmon",
            "category": "seafood"
        },
        {
            "uid": "b264e7e6e8dd",
            "name": "Sole",
            "category": "seafood"
        },
        {
            "uid": "5f8f42bef149",
            "name": "Fish cake",
            "category": "seafood"
        },
        {
            "uid": "bc3ed4f3b6cc",
            "name": "Rockfish",
            "category": "seafood"
        },
        {
            "uid": "fee440f97a52",
            "name": "Skipjack Tuna",
            "category": "seafood"
        },
        {
            "uid": "e073311cf0a0",
            "name": "Smoked Salmon",
            "category": "seafood"
        },
        {
            "uid": "f336244341a3",
            "name": "Smoked Sockeye Salmon",
            "category": "seafood"
        },
        {
            "uid": "7abcef214cc9",
            "name": "Surimi",
            "category": "seafood"
        },
        {
            "uid": "fe9ddaa4dbf9",
            "name": "Swordfish",
            "category": "seafood"
        },
        {
            "uid": "5e89f47a8b33",
            "name": "Tilapia",
            "category": "seafood"
        },
        {
            "uid": "2523c6eb49a5",
            "name": "Branzino",
            "category": "seafood"
        },
        {
            "uid": "a32fedd1b8fd",
            "name": "Mackerel",
            "category": "seafood"
        },
        {
            "uid": "e7cccd36b9d6",
            "name": "Yellowfin Tuna",
            "category": "seafood"
        },
        // ##### PROTEINS #####
        {
            "uid": "6b73d4cf970e",
            "name": "Beef",
            "category": "meat"
        },
        {
            "uid": "25e05ca46c0d",
            "name": "Chicken",
            "category": "meat"
        },
        {
            "uid": "95195317f36a",
            "name": "Duck",
            "category": "meat"
        },
        {
            "uid": "57745a15641d",
            "name": "Goat",
            "category": "meat"
        },
        {
            "uid": "53d317a109fe",
            "name": "Lamb",
            "category": "meat"
        },
        
        {
            "uid": "5e76006d9892",
            "name": "Pork",
            "category": "meat"
        },
        {
            "uid": "1202a5bea68c",
            "name": "Bacon",
            "category": "meat"
        },
        {
            "uid": "e49f5ee5d452",
            "name": "Turkey",
            "category": "meat"
        },
        {
            "uid": "d0aa669b5f9d",
            "name": "Veal",
            "category": "meat"
        },
        // ##### VEGGIES #####
        {
            "uid": "f510a6ff8585",
            "name": "Artichoke",
            "category": "veggies"
        },
        {
            "uid": "3f9b42bc6e33",
            "name": "Asparagus",
            "category": "veggies"
        },
        {
            "uid": "86770adbc8de",
            "name": "Avocado",
            "category": "veggies"
        },
        {
            "uid": "df2e900f012f",
            "name": "Baby Carrot",
            "category": "veggies"
        },
        {
            "uid": "ba9138ee7dbc",
            "name": "Beet",
            "category": "veggies"
        },
        {
            "uid": "1ba5d7652073",
            "name": "Bell pepper",
            "category": "veggies"
        },
        {
            "uid": "b7ddc74c04de",
            "name": "Black Beans",
            "category": "veggies"
        },
        {
            "uid": "c097fe4f7879",
            "name": "Broccoli",
            "category": "veggies"
        },
        {
            "uid": "4a4f428be124",
            "name": "Brussels sprout",
            "category": "veggies"
        },
        {
            "uid": "fd75fc367ed1",
            "name": "Cabbage",
            "category": "veggies"
        },
        {
            "uid": "24fa141a205a",
            "name": "Carrot",
            "category": "veggies"
        },
        {
            "uid": "686cd63d521e",
            "name": "Cauliflower",
            "category": "veggies"
        },
        {
            "uid": "22ee58c339b8",
            "name": "Celery",
            "category": "veggies"
        },
        {
            "uid": "5add50fd0dfb",
            "name": "Chili pepper",
            "category": "veggies"
        },
        {
            "uid": "f44414b7fca4",
            "name": "Chives",
            "category": "veggies"
        },
        {
            "uid": "46c11d8d7848",
            "name": "Collard greens",
            "category": "veggies"
        },
        {
            "uid": "5b87fe0f8769",
            "name": "Corn",
            "category": "veggies"
        },
        {
            "uid": "2db93920336e",
            "name": "Cucumber",
            "category": "veggies"
        },
        {
            "uid": "cfac2626486f",
            "name": "Edamame",
            "category": "veggies"
        },
        {
            "uid": "14e9952d64ce",
            "name": "Eggplant",
            "category": "veggies"
        },
        {
            "uid": "872adf4d3f67",
            "name": "Fennel",
            "category": "veggies"
        },
        {
            "uid": "9659c2a0fe08",
            "name": "Garlic",
            "category": "veggies"
        },
        {
            "uid": "b9809dd1e5a5",
            "name": "Ginger",
            "category": "veggies"
        },
        {
            "uid": "a9dfc2ee1958",
            "name": "Green bean",
            "category": "veggies"
        },
        {
            "uid": "9d5f045119e8",
            "name": "Green bell pepper",
            "category": "veggies"
        },
        {
            "uid": "b111ce353443",
            "name": "Habanero chili",
            "category": "veggies"
        },
        {
            "uid": "7f00ca7d3623",
            "name": "Jackfruit",
            "category": "veggies"
        },
        {
            "uid": "474c6471d7ff",
            "name": "Jalapeño",
            "category": "veggies"
        },
        {
            "uid": "f8908e42bac3",
            "name": "Jerusalem artichoke",
            "category": "veggies"
        },
        {
            "uid": "d0b7f4bc3ad7",
            "name": "Kale",
            "category": "veggies"
        },
        {
            "uid": "8bd6e8e958d2",
            "name": "Leek",
            "category": "veggies"
        },
        {
            "uid": "2ce97b84e3a4",
            "name": "Lettuce",
            "category": "veggies"
        },
        {
            "uid": "5aaffbe2245d",
            "name": "Lima Bean",
            "category": "veggies"
        },
        {
            "uid": "f16066dc5b59",
            "name": "Mushroom",
            "category": "veggies"
        },
        {
            "uid": "f77baf859d14",
            "name": "Okra",
            "category": "veggies"
        },
        {
            "uid": "e79287f186dc",
            "name": "Olives",
            "category": "veggies"
        },
        {
            "uid": "795695d9af48",
            "name": "Onion",
            "category": "veggies"
        },
        {
            "uid": "346fea5d73dd",
            "name": "Parsnip",
            "category": "veggies"
        },
        {
            "uid": "578daff9e7de",
            "name": "Pea",
            "category": "veggies"
        },
        {
            "uid": "fd8bfda538e3",
            "name": "Pinto Beans",
            "category": "veggies"
        },
        {
            "uid": "66201346bfda",
            "name": "Potato",
            "category": "veggies"
        },
        {
            "uid": "e1a5974a47fc",
            "name": "Pumpkin",
            "category": "veggies"
        },
        {
            "uid": "3174a1ac7a09",
            "name": "Radish",
            "category": "veggies"
        },
        {
            "uid": "c2862b15b40a",
            "name": "Red Cabbage",
            "category": "veggies"
        },
        {
            "uid": "1d25aab943f1",
            "name": "Red bell pepper",
            "category": "veggies"
        },
        {
            "uid": "123efd02c32a",
            "name": "Red onion",
            "category": "veggies"
        },
        {
            "uid": "ce0c8f9ea88f",
            "name": "Rhubarb",
            "category": "veggies"
        },
        {
            "uid": "f346b8e058fd",
            "name": "Rocket/Arugula",
            "category": "veggies"
        },
        {
            "uid": "b240147b343c",
            "name": "Romaine lettuce",
            "category": "veggies"
        },
        {
            "uid": "89a2e13b8621",
            "name": "Snap pea",
            "category": "veggies"
        },
        {
            "uid": "987a358b4981",
            "name": "Spinach",
            "category": "veggies"
        },
        {
            "uid": "a613ddf5fe3d",
            "name": "Squash",
            "category": "veggies"
        },
        {
            "uid": "e8b9047db063",
            "name": "Sweet corn",
            "category": "veggies"
        },
        {
            "uid": "b3282df56203",
            "name": "Sweet potato",
            "category": "veggies"
        },
        {
            "uid": "239a1961a9db",
            "name": "Taro",
            "category": "veggies"
        },
        {
            "uid": "8a200c49d9cf",
            "name": "Watercress",
            "category": "veggies"
        },
        {
            "uid": "abe67ac9f007",
            "name": "Yams",
            "category": "veggies"
        },
        {
            "uid": "59224def97f9",
            "name": "Yellow onion",
            "category": "veggies"
        },
        {
            "uid": "6aa5a5bbb401",
            "name": "Zucchini",
            "category": "veggies"
        },
        // #### HERBS ####
        {
            "uid": "1a67bfe89bfd",
            "name": "Basil",
            "category": "herbs",
            "asin": "B07GY51DHL"
        },
        {
            "uid": "3ab3cbc2c0d7",
            "name": "Chives",
            "category": "herbs",
            "asin": "B079JT3M9N"
        },
        {
            "uid": "858c51df0dc6",
            "name": "Cilantro",
            "category": "herbs",
            "asin": "B07819RK9C"
        },
        {
            "uid": "cd1570c33b4c",
            "name": "Parsley",
            "category": "herbs",
            "asin": ""
        },
        {
            "uid": "c68776b05127",
            "name": "Curly Parsley",
            "category": "herbs",
            "asin": "B07HFCK9G7"
        },
        {
            "uid": "dc845398ba25",
            "name": "Dill",
            "category": "herbs",
            "asin": "B0781434KV"
        },
        {
            "uid": "0263de9b7027",
            "name": "Italian Parsley",
            "category": "herbs",
            "asin": "B0781B3YD8"
        },
        {
            "uid": "f2875d0815f0",
            "name": "Mint",
            "category": "herbs",
            "asin": "B07GYNCJFZ"
        },
        {
            "uid": "8a65e148d5d6",
            "name": "Oregano",
            "category": "herbs",
            "asin": "B079JY4SYG"
        },
        {
            "uid": "f93f8656d553",
            "name": "Poultry Herbs",
            "category": "herbs",
            "asin": "B079JQL6MK"
        },
        {
            "uid": "6824cdc1bcb0",
            "name": "Rosemary",
            "category": "herbs",
            "asin": "B07FY8NYN3"
        },
        {
            "uid": "ac864860ae89",
            "name": "Sage",
            "category": "herbs",
            "asin": "B07FXX8GF6"
        },
        {
            "uid": "e654421bb9c7",
            "name": "Thyme",
            "category": "herbs",
            "asin": "B000RGYJW2"
        },
        // ##### CHEESE #####
        {
            "uid": "",
            "name": "Cheddar - Sharp",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Cheddar - Medium",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Cheddar - Mild",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Mozzarella",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Parmesan",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Feta",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Halloumi",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Gruyere",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Mexican Blend",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Oxaca Cheese",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Parmesan",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Gouda",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Swiss",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "American",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Manchego",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Cottage Cheese",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Goat",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Babybel",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Cream Cheese",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Monterrey JAck",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Provolone",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Pecorino Romano",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Brie",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Triple Cream",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Ricotta",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Mozzarella sticks",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Halloumi",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Pepper Jack",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Boursin",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Comte",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Emmental",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Blue",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Roquefort",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Mascarpone",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Raclette",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Queso Fresco",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Camembert",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Gorgonzola",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Mimolette",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Cotija",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Cheese Spread",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Burrata",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Muenster",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Fontina",
            "category": "cheese"
        },{
            "uid": "",
            "name": "Pecorino",
            "category": "cheese"
        },
        {
            "uid": "",
            "name": "Paneer",
            "category": "cheese"
        },
        // ##### DELI #####
        {
            "uid": "",
            "name": "Prosciutto",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Salami",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Genoa Salami",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Italian Deli Selection",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Pepperoni",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Spanish Deli Selection",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Spanish Chorizo",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Ham",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Black Forest Ham",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Varzi",
            "category": "deli"
        },{
            "uid": "",
            "name": "Peppercorn Salami",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Spicy Salami",
            "category": "deli"
        },{
            "uid": "",
            "name": "Jamon Serrano",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "French style Ham",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Sopressata",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Speck",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Virginia Ham",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Mortadella",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Saucisson",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Finocchiona",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Beef Bilogna",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Pastrami",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Sliced Chicken Breast",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Turkey Pepperoni",
            "category": "deli"
        },
        {
            "uid": "",
            "name": "Turkey Sliced Breast",
            "category": "deli"
        },
        // ##### NUTS #####
        {
            "uid": "",
            "name": "Almonds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Walnuts",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Pistachios",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Pecans",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Cashews",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Pine Nuts",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Hazelnuts",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Brazil Nuts",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Macadamias",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Peanuts",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Sunflower Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Chia Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Flax Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Pumpkin Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Poppy Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Sesame Seeds",
            "category": "nuts"
        },
        {
            "uid": "",
            "name": "Hemp Seeds",
            "category": "nuts"
        },
        // ##### CANNED GOODS ##### 
        {
            "uid": "",
            "name": "Black Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Garbanzo Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Chickpeas",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Albacore Tuna",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Cannellini Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Sauerkraut",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Sundried Tomatoes",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Pumpkin Puree",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Tomato Paste",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Yellowfin Tuna",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Kidney Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Crushed Tomatoes",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Pinto Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Artichoke Hearts",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Kalamata Olives",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Whole Peeled Tomatoes",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Skipjack Tuna",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Diced Tomatoes",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Sweet Corn",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Chicken Base",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Green Olives",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Lentils",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Heart of Palm",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Pink Salmon",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Refried Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Baked Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Green Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Veggie Base",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Beef Base",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Jellied Cranberry Sauce",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Apple Sauce",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Cinnamon Apple Sauce",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Sardines",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Chopped Clams",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Mushrooms",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Anchovies",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Jalapenos",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Soup",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Navy Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Peaches",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Pears",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Beets",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Black-eyed Peas",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Chili Beans",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Pineapple",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Maraschino Cherries",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Canned Peppers",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Lobster Bisque",
            "category": "canned"
        },
        {
            "uid": "",
            "name": "Green Peas",
            "category": "canned"
        },
        // ##### FROZEN  #####
        {
            "uid": "",
            "name": "Ice Cream",
            "category": "frozen"
        },
        {
            "uid": "",
            "name": "Green Peas",
            "category": "frozen"
        },
    ],
    "pc_users" : [
        {
            "uid" : "user_0",
            "name" : "Me",
            "picUrl" : "",
            "diets" : [
                {"vegetarian":false},
                {"vegan":false},
                {"gluten free":false},
                {"dairy free":false},
                {"kosher":false},
                {"halal":false}
            ],
            "type" : "user",
            "like" : [],
            "dislike" : []
        }
    ]
};

export const generateDummyData = async () => {
    console.log('generating dummy data');
    const pc_preferences = [];
    const pc_recurring = [];
    const pc_items = [
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9868",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Carrots",
            "category":"veggies",
            "collected":false,
            "status":"it_collected",
            "qty":2,
            "unit":"Lbs",
            "aisle":"A12",
            "lastUpdate":""
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9768",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Beetroots",
            "category":"veggies",
            "collected":false,
            "status":"it_skipped",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A14"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9812",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Potatoes",
            "category":"veggies",
            "collected":false,
            "status":"it_collected",
            "qty":3.5,
            "unit":"Lbs",
            "aisle":"A14"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9823",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Spinach",
            "category":"veggies",
            "collected":false,
            "status":"it_collected",
            "qty":0.5,
            "unit":"Lbs",
            "aisle":"A18"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9634",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Chicken",
            "category":"meat",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"B10"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d8868",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Mint",
            "category":"herbs",
            "collected":false,
            "status":"it_none",
            "qty":2,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-ga74b22d9768",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Bread",
            "category":"bakery",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A14"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a72b22d9812",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"AP Flour",
            "category":"baking",
            "collected":false,
            "status":"it_none",
            "qty":3.5,
            "unit":"Lbs",
            "aisle":"A14"
        },
        {
            "uid":"fseda994-92cf-4b1a-ad1c-8a74b22d9823",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Baking powder",
            "category":"coffee tea",
            "collected":false,
            "status":"it_none",
            "qty":0.5,
            "unit":"Lbs",
            "aisle":"A18"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9634",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Farfalle",
            "category":"cereals",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"B10"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9845",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Skirt steak",
            "category":"meat",
            "collected":false,
            "status":"it_none",
            "qty":1,
            "unit":"Lbs",
            "aisle":"B11"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9867",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Yogurt",
            "category":"dairy",
            "collected":false,
            "status":"it_none",
            "qty":2,
            "unit":"Lbs",
            "aisle":"C8"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9878",
            "listUid":"ac652845-e96f-4e6a-a745-2cafef5ed41g",
            "name":"Milk",
            "category":"dairy",
            "collected":false,
            "status":"it_none",
            "qty":1,
            "unit":"Gal",
            "aisle":"C8"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9889",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Salmon",
            "category":"seafood",
            "collected":false,
            "status":"it_none",
            "qty":1.5,
            "unit":"Lbs",
            "aisle":"D32"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9891",
            "listUid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Tuna",
            "category":"seafood",
            "collected":false,
            "status":"it_none",
            "qty":0.5,
            "unit":"Lbs",
            "aisle":"D32"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9719",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Cod fillet",
            "category":"seafood",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9798",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Pineapple",
            "category":"fruits",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9787",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Mango",
            "category":"fruits",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9776",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Strawberries",
            "category":"fruits",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9765",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Kiwi",
            "category":"fruits",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9754",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Salad",
            "category":"veggies",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9743",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Lentils",
            "category":"veggies",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9732",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Soybean",
            "category":"veggies",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9721",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Oatmilk",
            "category":"dairy",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9710",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Tofu",
            "category":"dairy",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9711",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Goat cheese",
            "category":"dairy",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        },
        {
            "uid":"ffeda994-92cf-4b1a-ad1c-8a74b22d9722",
            "listUid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Watermelon",
            "category":"fruits",
            "collected":false,
            "status":"it_none",
            "qty":3,
            "unit":"Lbs",
            "aisle":"A12"
        }
    ];
    const pc_recent = [
        {
            uid: "stores",
            entries: [
                {
                    uid: "4e3a",
                    logoId: "4e3a",
                    name: "Amazon Fresh"
                }
            ]
        },
        {
            uid: 'items_all',
            entries: [
                {uid:"mango",name:"mango",category:"fruits"},
                {uid:"steak",name:"steak",category:"meat"},
                {uid:"wipes",name:"wipes",category:"baby"},
                {uid:"applesauce",name:"applesauce",category:"baby"},
                {uid:"oatmeal",name:"oatmeal",category:"cereals"}
            ]
        },
        {
            "uid": "items_veggies",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "veggies"
                }
            ]
        },
        {
            "uid": "items_fruits",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "fruits"
                }
            ]
        },
        {
            "uid": "items_herbs",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "herbs"
                }
            ]
        },
        {
            "uid": "items_meat",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "meat"
                }
            ]
        },
        {
            "uid": "items_seafood",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "seafood"
                }
            ]
        },
        {
            "uid": "items_dairy",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "dairy"
                }
            ]
        },
        {
            "uid": "items_cheese",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "cheese"
                }
            ]
        },
        {
            "uid": "items_deli",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "deli"
                }
            ]
        },
        {
            "uid": "items_ready-made",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "ready-made"
                }
            ]
        },
        {
            "uid": "items_condiments",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "condiments"
                }
            ]
        },
        {
            "uid": "items_spices",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "spices"
                }
            ]
        },
        {
            "uid": "items_oil",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "oil"
                }
            ]
        },
        {
            "uid": "items_snacks",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "snacks"
                }
            ]
        },
        {
            "uid": "items_nuts",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "nuts"
                }
            ]
        },
        {
            "uid": "items_baking",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "baking"
                }
            ]
        },
        {
            "uid": "items_cereals",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "cereals"
                }
            ]
        },
        {
            "uid": "items_bakery",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "bakery"
                }
            ]
        },
        {
            "uid": "items_beverages",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "beverages"
                }
            ]
        },
        {
            "uid": "items_coffee tea",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "coffee tea"
                }
            ]
        },
        {
            "uid": "items_alcohol",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "alcohol"
                }
            ]
        },
        {
            "uid": "items_canned",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "canned"
                }
            ]
        },
        {
            "uid": "items_frozen",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "frozen"
                }
            ]
        },
        {
            "uid": "items_personal care",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "personal care"
                }
            ]
        },
        {
            "uid": "items_baby",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "baby"
                }
            ]
        },
        {
            "uid": "items_household",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "household"
                }
            ]
        },
        {
            "uid": "items_pet",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "pet"
                }
            ]
        },
        {
            "uid": "items_misc",
            "entries": [
                {
                    "uid": "mango",
                    "name": "mango",
                    "category": "misc"
                }
            ]
        }
    ];
    const pc_products = [
        {
            "uid": "402385af9467",
            "name": "Apples",
            "category": "fruits"
        },
        {
            "uid": "a6ba547d18ab",
            "name": "Apricots",
            "category": "fruits"
        },
        {
            "uid": "d62cb573ffb2",
            "name": "Aprium",
            "category": "fruits"
        },
        {
            "uid": "081fa364177c",
            "name": "Asian Pears",
            "category": "fruits"
        },
        {
            "uid": "6c37f781dea6",
            "name": "Açai Berry",
            "category": "fruits"
        },
        {
            "uid": "4b09f11a1421",
            "name": "Bananas",
            "category": "fruits"
        },
        {
            "uid": "8f1581664adc",
            "name": "Berries",
            "category": "fruits"
        },
        {
            "uid": "14ea10c413ad",
            "name": "Bing Cherries",
            "category": "fruits"
        },
        {
            "uid": "b58bc56688e3",
            "name": "Black Cherry",
            "category": "fruits"
        },
        {
            "uid": "18cfc3bb4281",
            "name": "Blackberries",
            "category": "fruits"
        },
        {
            "uid": "916595c32e4a",
            "name": "Blood oranges",
            "category": "fruits"
        },
        {
            "uid": "e8e8656b79c9",
            "name": "Blueberries",
            "category": "fruits"
        },
        {
            "uid": "f7e4b9da6421",
            "name": "Cantaloupes",
            "category": "fruits"
        },
        {
            "uid": "1ea6b44db2a8",
            "name": "Carambola",
            "category": "fruits"
        },
        {
            "uid": "e7ac1e584c3f",
            "name": "Cherimoya",
            "category": "fruits"
        },
        {
            "uid": "2bc5fd86e48a",
            "name": "Cherries",
            "category": "fruits"
        },
        {
            "uid": "60701f331af2",
            "name": "Coconuts",
            "category": "fruits"
        },
        {
            "uid": "516cb8b8a657",
            "name": "Cranberries",
            "category": "fruits"
        },
        {
            "uid": "4aca81ac2dd6",
            "name": "Dates",
            "category": "fruits"
        },
        {
            "uid": "8730d2bf7ba8",
            "name": "Dragon Fruits",
            "category": "fruits"
        },
        {
            "uid": "2b436c286e62",
            "name": "Durian",
            "category": "fruits"
        },
        {
            "uid": "1a8db2b01ffe",
            "name": "Figs",
            "category": "fruits"
        },
        {
            "uid": "68e0d7b9dd78",
            "name": "Goji Berry",
            "category": "fruits"
        },
        {
            "uid": "d69c71cb5e82",
            "name": "Golden Apples",
            "category": "fruits"
        },
        {
            "uid": "a9df697f4d33",
            "name": "Gooseberry",
            "category": "fruits"
        },
        {
            "uid": "d205c20cd124",
            "name": "Grapefruits",
            "category": "fruits"
        },
        {
            "uid": "2fdb09bcf6e3",
            "name": "Grapes",
            "category": "fruits"
        },
        {
            "uid": "c279ce294668",
            "name": "Green Apples",
            "category": "fruits"
        },
        {
            "uid": "979e5cdcac4d",
            "name": "Guavas",
            "category": "fruits"
        },
        {
            "uid": "02628c47901a",
            "name": "Honey Crisp Apple",
            "category": "fruits"
        },
        {
            "uid": "c66d440cf138",
            "name": "Honeydew melons",
            "category": "fruits"
        },
        {
            "uid": "5982066705a1",
            "name": "Huckleberry",
            "category": "fruits"
        },
        {
            "uid": "795af838bf7c",
            "name": "Jackfruit",
            "category": "fruits"
        },
        {
            "uid": "fd36fd664fb2",
            "name": "Key lime",
            "category": "fruits"
        },
        {
            "uid": "ddfff4f97d85",
            "name": "Kiwis",
            "category": "fruits"
        },
        {
            "uid": "d1d836d2139b",
            "name": "Kumquat",
            "category": "fruits"
        },
        {
            "uid": "699ffdce4fcd",
            "name": "Lemons",
            "category": "fruits"
        },
        {
            "uid": "7e7651f8f15f",
            "name": "Limes",
            "category": "fruits"
        },
        {
            "uid": "4a7847d40132",
            "name": "Longan",
            "category": "fruits"
        },
        {
            "uid": "e32bd7ee3d3a",
            "name": "Lychees",
            "category": "fruits"
        },
        {
            "uid": "31eb972c627c",
            "name": "Mandarin",
            "category": "fruits"
        },
        {
            "uid": "314bc1a7ac54",
            "name": "Mangos",
            "category": "fruits"
        },
        {
            "uid": "2daf1343d66a",
            "name": "Melons",
            "category": "fruits"
        },
        {
            "uid": "8b1a64496a34",
            "name": "Meyer Lemons",
            "category": "fruits"
        },
        {
            "uid": "52ec9e08925d",
            "name": "Nectarines",
            "category": "fruits"
        },
        {
            "uid": "601fb9f7cb72",
            "name": "Oranges",
            "category": "fruits"
        },
        {
            "uid": "ca778f258249",
            "name": "Papayas",
            "category": "fruits"
        },
        {
            "uid": "3d31e56e5001",
            "name": "Passion fruits",
            "category": "fruits"
        },
        {
            "uid": "1543f698fb2c",
            "name": "Peaches",
            "category": "fruits"
        },
        {
            "uid": "eee745b79ce8",
            "name": "Pears",
            "category": "fruits"
        },
        {
            "uid": "20d383f89bc9",
            "name": "Persimmon",
            "category": "fruits"
        },
        {
            "uid": "cdb796ce3af3",
            "name": "Pineapples",
            "category": "fruits"
        },
        {
            "uid": "b18886438b8d",
            "name": "Plums",
            "category": "fruits"
        },
        {
            "uid": "e0265994a955",
            "name": "Pluot",
            "category": "fruits"
        },
        {
            "uid": "db061060ff83",
            "name": "Pomegranates",
            "category": "fruits"
        },
        {
            "uid": "a7e382663caa",
            "name": "Pomelo",
            "category": "fruits"
        },
        {
            "uid": "107238550887",
            "name": "Prickly Pear",
            "category": "fruits"
        },
        {
            "uid": "c47e7a25fcd8",
            "name": "Purple mangosteen",
            "category": "fruits"
        },
        {
            "uid": "66d81bb6b031",
            "name": "Quince",
            "category": "fruits"
        },
        {
            "uid": "8cf22ffdd41d",
            "name": "Rambutans",
            "category": "fruits"
        },
        {
            "uid": "49ca07dee535",
            "name": "Raspberries",
            "category": "fruits"
        },
        {
            "uid": "9f33e6db271e",
            "name": "Rhubarbs",
            "category": "fruits"
        },
        {
            "uid": "ebee00dc029c",
            "name": "Sapodilla",
            "category": "fruits"
        },
        {
            "uid": "88837921a9fa",
            "name": "Sour Cherries",
            "category": "fruits"
        },
        {
            "uid": "bb710ef63fd8",
            "name": "Soursop",
            "category": "fruits"
        },
        {
            "uid": "c15aeb1be5fd",
            "name": "Strawberries",
            "category": "fruits"
        },
        {
            "uid": "97da8b6b80d0",
            "name": "Sugarcane",
            "category": "fruits"
        },
        {
            "uid": "3a8a125adf68",
            "name": "Tangelo",
            "category": "fruits"
        },
        {
            "uid": "3beeb41f6505",
            "name": "Tangerines",
            "category": "fruits"
        },
        {
            "uid": "c537f977d21d",
            "name": "Victoria Plum",
            "category": "fruits"
        },
        {
            "uid": "42377a57df57",
            "name": "Walnuts",
            "category": "fruits"
        },
        {
            "uid": "89f20890a4a2",
            "name": "Watermelons",
            "category": "fruits"
        },
        {
            "uid": "7a85a3e5dd94",
            "name": "star fruit",
            "category": "fruits"
        },
        {
            "uid": "6b73d4cf970e",
            "name": "Beef",
            "category": "meat"
        },
        {
            "uid": "f72a78cce757",
            "name": "Buffalo",
            "category": "meat"
        },
        {
            "uid": "25e05ca46c0d",
            "name": "Chicken",
            "category": "meat"
        },
        {
            "uid": "95195317f36a",
            "name": "Duck",
            "category": "meat"
        },
        {
            "uid": "57745a15641d",
            "name": "Goat",
            "category": "meat"
        },
        {
            "uid": "e07939b7a22e",
            "name": "Goose",
            "category": "meat"
        },
        {
            "uid": "6b524cd18065",
            "name": "Kangaroo",
            "category": "meat"
        },
        {
            "uid": "53d317a109fe",
            "name": "Lamb",
            "category": "meat"
        },
        {
            "uid": "ec0b12d6fd4a",
            "name": "Pheasant",
            "category": "meat"
        },
        {
            "uid": "c5104699e36a",
            "name": "Pigeon",
            "category": "meat"
        },
        {
            "uid": "5e76006d9892",
            "name": "Pork",
            "category": "meat"
        },
        {
            "uid": "1202a5bea68c",
            "name": "Quail",
            "category": "meat"
        },
        {
            "uid": "e2e44b578dde",
            "name": "Rabbit",
            "category": "meat"
        },
        {
            "uid": "e49f5ee5d452",
            "name": "Turkey",
            "category": "meat"
        },
        {
            "uid": "d0aa669b5f9d",
            "name": "Veal",
            "category": "meat"
        },
        {
            "uid": "a522530f2afe",
            "name": "Venison",
            "category": "meat"
        },
        {
            "uid": "19d75d942713",
            "name": "mint",
            "category": "herbs"
        },
        {
            "uid": "f510a6ff8585",
            "name": "Artichoke",
            "category": "veggies"
        },
        {
            "uid": "3f9b42bc6e33",
            "name": "Asparagus",
            "category": "veggies"
        },
        {
            "uid": "86770adbc8de",
            "name": "Avocado",
            "category": "veggies"
        },
        {
            "uid": "df2e900f012f",
            "name": "Baby Carrot",
            "category": "veggies"
        },
        {
            "uid": "ba9138ee7dbc",
            "name": "Beet",
            "category": "veggies"
        },
        {
            "uid": "1ba5d7652073",
            "name": "Bell pepper",
            "category": "veggies"
        },
        {
            "uid": "b7ddc74c04de",
            "name": "Black Beans",
            "category": "veggies"
        },
        {
            "uid": "c097fe4f7879",
            "name": "Broccoli",
            "category": "veggies"
        },
        {
            "uid": "4a4f428be124",
            "name": "Brussels sprout",
            "category": "veggies"
        },
        {
            "uid": "fd75fc367ed1",
            "name": "Cabbage",
            "category": "veggies"
        },
        {
            "uid": "24fa141a205a",
            "name": "Carrot",
            "category": "veggies"
        },
        {
            "uid": "686cd63d521e",
            "name": "Cauliflower",
            "category": "veggies"
        },
        {
            "uid": "22ee58c339b8",
            "name": "Celery",
            "category": "veggies"
        },
        {
            "uid": "5add50fd0dfb",
            "name": "Chili pepper",
            "category": "veggies"
        },
        {
            "uid": "f44414b7fca4",
            "name": "Chives",
            "category": "veggies"
        },
        {
            "uid": "46c11d8d7848",
            "name": "Collard greens",
            "category": "veggies"
        },
        {
            "uid": "5b87fe0f8769",
            "name": "Corn",
            "category": "veggies"
        },
        {
            "uid": "2db93920336e",
            "name": "Cucumber",
            "category": "veggies"
        },
        {
            "uid": "cfac2626486f",
            "name": "Edamame",
            "category": "veggies"
        },
        {
            "uid": "14e9952d64ce",
            "name": "Eggplant",
            "category": "veggies"
        },
        {
            "uid": "872adf4d3f67",
            "name": "Fennel",
            "category": "veggies"
        },
        {
            "uid": "9659c2a0fe08",
            "name": "Garlic",
            "category": "veggies"
        },
        {
            "uid": "b9809dd1e5a5",
            "name": "Ginger",
            "category": "veggies"
        },
        {
            "uid": "a9dfc2ee1958",
            "name": "Green bean",
            "category": "veggies"
        },
        {
            "uid": "9d5f045119e8",
            "name": "Green bell pepper",
            "category": "veggies"
        },
        {
            "uid": "b111ce353443",
            "name": "Habanero chili",
            "category": "veggies"
        },
        {
            "uid": "7f00ca7d3623",
            "name": "Jackfruit",
            "category": "veggies"
        },
        {
            "uid": "474c6471d7ff",
            "name": "Jalapeño",
            "category": "veggies"
        },
        {
            "uid": "f8908e42bac3",
            "name": "Jerusalem artichoke",
            "category": "veggies"
        },
        {
            "uid": "d0b7f4bc3ad7",
            "name": "Kale",
            "category": "veggies"
        },
        {
            "uid": "8bd6e8e958d2",
            "name": "Leek",
            "category": "veggies"
        },
        {
            "uid": "2ce97b84e3a4",
            "name": "Lettuce",
            "category": "veggies"
        },
        {
            "uid": "5aaffbe2245d",
            "name": "Lima Bean",
            "category": "veggies"
        },
        {
            "uid": "f16066dc5b59",
            "name": "Mushroom",
            "category": "veggies"
        },
        {
            "uid": "f77baf859d14",
            "name": "Okra",
            "category": "veggies"
        },
        {
            "uid": "e79287f186dc",
            "name": "Olives",
            "category": "veggies"
        },
        {
            "uid": "795695d9af48",
            "name": "Onion",
            "category": "veggies"
        },
        {
            "uid": "346fea5d73dd",
            "name": "Parsnip",
            "category": "veggies"
        },
        {
            "uid": "578daff9e7de",
            "name": "Pea",
            "category": "veggies"
        },
        {
            "uid": "fd8bfda538e3",
            "name": "Pinto Beans",
            "category": "veggies"
        },
        {
            "uid": "66201346bfda",
            "name": "Potato",
            "category": "veggies"
        },
        {
            "uid": "e1a5974a47fc",
            "name": "Pumpkin",
            "category": "veggies"
        },
        {
            "uid": "3174a1ac7a09",
            "name": "Radish",
            "category": "veggies"
        },
        {
            "uid": "c2862b15b40a",
            "name": "Red Cabbage",
            "category": "veggies"
        },
        {
            "uid": "1d25aab943f1",
            "name": "Red bell pepper",
            "category": "veggies"
        },
        {
            "uid": "123efd02c32a",
            "name": "Red onion",
            "category": "veggies"
        },
        {
            "uid": "ce0c8f9ea88f",
            "name": "Rhubarb",
            "category": "veggies"
        },
        {
            "uid": "f346b8e058fd",
            "name": "Rocket/Arugula",
            "category": "veggies"
        },
        {
            "uid": "b240147b343c",
            "name": "Romaine lettuce",
            "category": "veggies"
        },
        {
            "uid": "89a2e13b8621",
            "name": "Snap pea",
            "category": "veggies"
        },
        {
            "uid": "987a358b4981",
            "name": "Spinach",
            "category": "veggies"
        },
        {
            "uid": "a613ddf5fe3d",
            "name": "Squash",
            "category": "veggies"
        },
        {
            "uid": "e8b9047db063",
            "name": "Sweet corn",
            "category": "veggies"
        },
        {
            "uid": "b3282df56203",
            "name": "Sweet potato",
            "category": "veggies"
        },
        {
            "uid": "239a1961a9db",
            "name": "Taro",
            "category": "veggies"
        },
        {
            "uid": "8a200c49d9cf",
            "name": "Watercress",
            "category": "veggies"
        },
        {
            "uid": "abe67ac9f007",
            "name": "Yams",
            "category": "veggies"
        },
        {
            "uid": "59224def97f9",
            "name": "Yellow onion",
            "category": "veggies"
        },
        {
            "uid": "6aa5a5bbb401",
            "name": "Zucchini",
            "category": "veggies"
        }
    ];
    const pc_lists = [
        {
            "uid":"ab652845-e96f-4e6a-a745-2cafef5ed41f",
            "name":"Whole Foods",
            "date":"2022-05-19",
            "status":"active",
            "storeId":"whole foods",
            "storeLogo":"ac40",
            "storeName":"whole foods",
            "assignedUser":null,
            "progress":0,
            "lastUpdated":1654198923681
        },
        {
            "uid":"cd652845-e96f-4e6a-a745-2cafef5ed41j",
            "name":"Target",
            "date":"2022-05-16",
            "status":"active",
            "storeId":"target",
            "storeLogo":"c2ea",
            "storeName":"target",
            "assignedUser":null,
            "progress":0,
            lastUpdated: 1654198966006
        },
        {
            "uid":"ac652845-e96f-4e6a-a745-2cafef5ed41g",
            "name":"Whole Foods",
            "date":"2022-05-19",
            "status":"recurring",
            "storeId":"whole foods",
            "storeLogo":"ac40",
            "storeName":"whole foods",
            "assignedUser":"151116c0-f313-4c8e-94da-e21c2a3730b1",
            "progress":0,
            lastUpdated: 1654198866006
        },
        {
            "uid":"ac652845-e96f-4e6a-a745-2cafef5ed41d",
            "name":"Trader Joe's",
            "date":"2022-05-03",
            "status":"recurring",
            "storeId":"trader joe's",
            "storeLogo":"20ef",
            "storeName":"trader joe's",
            "assignedUser":"151116c0-f313-4c8e-94da-e21c2a3730b0",
            "progress":0,
            lastUpdated: 1654198866000
        }
        ,{
            "uid":"ac652845-e96f-4e6a-a745-2cafef5ed41g",
            "name":"Whole Foods",
            "date":"2022-05-19",
            "status":"recurring",
            "storeId":"whole foods",
            "storeLogo":"ac40",
            "storeName":"whole foods",
            "assignedUser":"151116c0-f313-4c8e-94da-e21c2a3730b0",
            "progress":0,
            lastUpdated: 1654198866003
        }
    ];
    
    const dbConnect = openDB(DB_NAME, DB_VERSION);
     
    pc_items.forEach( async item => (await dbConnect).add('pc_items', item) );
    pc_recent.forEach( async recent => (await dbConnect).add('pc_recent', recent) );
    pc_products.forEach( async product => (await dbConnect).add('pc_products', product) );
    pc_lists.forEach( async list => (await dbConnect).add('pc_lists', list) );

    (await dbConnect).close()
};

export const setDefaultValuesIfMissing = async (tb) => {
    const dbConnect = openDB(DB_NAME, DB_VERSION);
    console.log('Set default values if missing');
    console.log(`[INFO] db.js > adding ${tb}`);
    dflt[tb].forEach( async entry => {
        //console.log(`${table}`,entry);
        const res = (await dbConnect).add(tb, entry);
        //console.log(res);
    });
    (await dbConnect).close()
};

const dbPromise = openDB(DB_NAME, DB_VERSION, {
    upgrade(upgradeDb, oldVersion, newVersion, tx) {
        console.log(`Upgrading to version ${DB_VERSION}`);

        let products, preferences, recurring, items, lists, stores, users, recent, misc_reco;

        switch (oldVersion) {
            case 0:
                // ibd first: products, Items, Recipes
                products = upgradeDb.createObjectStore('pc_products', {keyPath: 'uid'});
                products.createIndex('category', 'category',{ unique: false });
                products.createIndex('name', 'name',{ unique: false });
                setDefaultValuesIfMissing(`pc_products`);

                recurring = upgradeDb.createObjectStore('pc_recurring', { keyPath: 'uid' });
                recurring.createIndex('next', 'next', {unique: false});

                items = upgradeDb.createObjectStore('pc_items', { keyPath: 'uid'});
                items.createIndex('listUid','listUid',{ unique: false });
                items.createIndex('productUid','productUid');
                // pc_items.forEach( item => items.put(item) );

                // idb persistence: Lists, Stores, Users, Recent store, Recent item 
                lists = upgradeDb.createObjectStore('pc_lists', {keyPath: 'uid'});
                lists.createIndex('lastUpdated', 'lastUpdated', {unique: false});
                lists.createIndex('storeUid', 'storeUid', {unique: false});

                stores = upgradeDb.createObjectStore('pc_stores', {keyPath: 'uid'});
                setDefaultValuesIfMissing(`pc_stores`);

                recent = upgradeDb.createObjectStore('pc_recent', {keyPath: 'uid'});

                misc_reco = upgradeDb.createObjectStore('pc_misc_reco', {keyPath: 'uid'});
                users = upgradeDb.createObjectStore('pc_users', {keyPath: 'uid'});
                setDefaultValuesIfMissing(`pc_users`);
            case 1:
                // misc_reco = tx.objectStore('pc_misc_reco');
        }
    }
});

export const idb = {
    generateDummyData: () => generateDummyData,
    get: async (store, key) => await (await dbPromise).get(store, key),
    getAll: async (store) => await ( await dbPromise).getAll(store),
    getAllFromIndex: {
        eq: async (store, index, val) => await ( await dbPromise).getAllFromIndex(store, index, val),
        gt: async (store, index, min) => await ( await dbPromise).getAllFromIndex(store, index, IDBKeyRange.lowerBound(min)),
        lt: async (store, index, max) => await ( await dbPromise).getAllFromIndex(store, index, IDBKeyRange.upperBound(max)),
        bt: async (store, index, [min , max]) => await ( await dbPromise).getAllFromIndex(store, index, IDBKeyRange.bound(min, max)),
        startWith: async (store, index, val) => { // Does not return the right dataset
            let res = [];
            let cursor = await ( await dbPromise ).transaction(store).store.index(index).openCursor();
            while (true) {
                res.push(cursor.value);
                cursor = await cursor.continue();
                if (!cursor) break;
            }
            return res;
        }
    },
    add: async (store, data) => (await dbPromise).add(store, data),
    set:  async (store, data, key) => (await dbPromise).put(store, data, key),
    delete: async (store, key) => await (await dbPromise).delete(store, key),
    count:  async (store, key) => await (await dbPromise).count(store, key),
    save: async (store, array) => { console.group(`INFO: ibd.save`);console.log(array);console.groupEnd(); array.forEach( async record => (await dbPromise).put(store, record) )}
};